import React, { useState, useEffect } from 'react';
import {
  Dialog, DialogTitle, DialogContent, DialogActions,
  Button, TextField, Grid, CircularProgress, Alert,
} from '@mui/material';
import cantinasService, { Escola } from '../../services/cantinas.service';

interface Props {
  open: boolean;
  onClose: () => void;
  onSaved: () => void;
  escola?: Escola | null;
}

const empty = { nome: '', cidade: 'Praia', nif: '', morada: '', contacto: '', email: '', responsavel: '', escola_admin_uid: '' };

const CantinasModal: React.FC<Props> = ({ open, onClose, onSaved, escola }) => {
  const [form, setForm] = useState({ ...empty });
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (escola) {
      setForm({
        nome: escola.nome || '',
        cidade: escola.cidade || 'Praia',
        nif: escola.nif || '',
        morada: escola.morada || '',
        contacto: escola.contacto || '',
        email: escola.email || '',
        responsavel: escola.responsavel || '',
        escola_admin_uid: escola.escola_admin_uid || '',
      });
    } else {
      setForm({ ...empty });
    }
    setError(null);
  }, [escola, open]);

  const f = (key: string) => ({
    value: (form as any)[key] || '',
    onChange: (e: React.ChangeEvent<HTMLInputElement>) => setForm({ ...form, [key]: e.target.value }),
  });

  async function handleSave() {
    if (!form.nome) return;
    setSaving(true); setError(null);
    try {
      if (escola) {
        await cantinasService.updateEscola(escola.id, form);
      } else {
        await cantinasService.createEscola(form);
      }
      onSaved(); onClose();
    } catch {
      setError('Erro ao guardar escola');
    } finally {
      setSaving(false);
    }
  }

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth
      PaperProps={{ sx: { borderRadius: 3 } }}>
      <DialogTitle fontWeight={700}>{escola ? 'Editar Escola' : 'Nova Escola'}</DialogTitle>
      <DialogContent dividers>
        {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
        <Grid container spacing={2} mt={0.5}>
          <Grid item xs={12}>
            <TextField label="Nome da Escola *" fullWidth {...f('nome')} />
          </Grid>
          <Grid item xs={6}>
            <TextField label="Cidade" fullWidth {...f('cidade')} />
          </Grid>
          <Grid item xs={6}>
            <TextField label="NIF" fullWidth {...f('nif')} />
          </Grid>
          <Grid item xs={12}>
            <TextField label="Morada" fullWidth {...f('morada')} />
          </Grid>
          <Grid item xs={6}>
            <TextField label="Responsável" fullWidth {...f('responsavel')} />
          </Grid>
          <Grid item xs={6}>
            <TextField label="Contacto" fullWidth {...f('contacto')} />
          </Grid>
          <Grid item xs={12}>
            <TextField label="Email" fullWidth {...f('email')} />
          </Grid>
          <Grid item xs={12}>
            <TextField label="UID Firebase do Admin da Escola" fullWidth {...f('escola_admin_uid')}
              helperText="Firebase UID do utilizador que gere esta escola" />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions sx={{ p: 2 }}>
        <Button onClick={onClose} disabled={saving}>Cancelar</Button>
        <Button variant="contained" onClick={handleSave} disabled={saving || !form.nome}
          startIcon={saving ? <CircularProgress size={16} /> : null}
          sx={{ bgcolor: '#6233A0', '&:hover': { bgcolor: '#4e2880' } }}>
          {escola ? 'Guardar' : 'Criar Escola'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CantinasModal;
